import { normalizePortalModulePath } from '../utils/helpers/normalizePortalModulePath'

export default {
  inject: {
    portalHomeLayout: { default: null },
  },
  computed: {
    portalScreenMenuItem() {
      const layout = this.portalHomeLayout
      if (!layout || typeof layout.findMenuItemByRouteKey !== 'function') return ''
      const tree = layout.menuTree
      if (!Array.isArray(tree) || !tree.length) return ''
      const routeKey = normalizePortalModulePath(this.$route.path).toLowerCase()
      return layout.findMenuItemByRouteKey(tree, routeKey)
    },
    portalScreenTitle() {
      const raw = this.portalScreenMenuItem?.title
      return raw != null ? String(raw).trim() : ''
    },
    portalScreenSubtitle() {
      const item = this.portalScreenMenuItem
      const raw = item?.tileCompleteDescription
      const s = raw != null ? String(raw).trim() : ''
      return s
    },
  },
}
